import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconExclamationAltActive } from "../../Experimental__Icon/icons/Experimental__IconExclamationAltActive";
import { Icon } from "../";
export function IconExclamationAltActive(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconExclamationAltActive, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M12 2a10 10 0 1010 10A10 10 0 0012 2zm-.5 5h1v7h-1zm.5 10.5a.85.85 0 11.85-.85.85.85 0 01-.85.85z\" fill=\"#181818\"/>"
    }
  }));
}
export default IconExclamationAltActive;